import { type FormSubmission } from "@overmap-ai/common"
import { FormIdentifierValueService as OvermapFormIdentifierValueService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class FormIdentifierValueService extends OvermapFormIdentifierValueService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL

	async refreshStoreForFormSubmission(formSubmissionId: FormSubmission["uuid"], signal?: AbortSignal) {
		const { addMany } = this.actions

		const result = await this.listPaginated(
			{
				queryParams: {
					form_submission: formSubmissionId,
				},
			},
			signal,
		)

		const flattened = result.flat()
		this.dispatch(addMany(flattened))
		return flattened
	}
}
